import React, { useState, useEffect } from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import { Helmet } from "react-helmet";
import { BsChevronRight } from 'react-icons/bs'
import StatusBadge from "../js/buttonstatus.jsx";
import { Cookies } from "../index.js";
import axios from "axios";
const ChangeHistory = ({ userOption }) => {
    const [history, sethistory] = useState(false);
    const totalPage = history ? Math.ceil(history.length / 10) : 1;
    const [pageStart, setPageStart] = useState(0)
    const [pageEnd, setPageEnd] = useState(10)
    const handleClick = (pageItem) => {
        setPageStart(0 + pageItem * 10)
        setPageEnd(10 + pageItem * 10)
    }
    const handleClickLeft = () => {
        if (pageStart >= 10) {
            setPageStart(pageStart - 10)
            setPageEnd(pageEnd - 10)
        }
    }
    const lichsudoithe = async () => {
        const apikey = Cookies.get("apikey");
        axios
            .get(
                "https://hust.media/api/topup_card/doithels.php?apikey=" + apikey
            )
            .then((response) => {
                console.log(response.data);
                sethistory(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleClickRight = () => {
        if (pageEnd <= history.length) {
            setPageStart(pageStart + 10)
            setPageEnd(pageEnd + 10)
        }
    }
    let intervalId;
    function startLichSuDoiThe() {
        intervalId = setInterval(() => {
            lichsudoithe();
        }, 7000);
    }
    useEffect(() => {
        lichsudoithe();
        startLichSuDoiThe();

        return () => clearInterval(intervalId);
    }, []);
    return (
        <>
            <Helmet>
                <title>Nhật ký đổi thẻ cào</title>
                <meta name="description" content="Nhật ký đổi thẻ cào" />
            </Helmet>
            {userOption === 'changeHistory' && history && (
                <div className='py-4 px-2 '>
                    <div className='bg-[#f5f6fa] rounded-md p-1'>
                        <div className='ml-2 border-blue-400 border-b inline'>Lịch sử đổi thẻ</div>
                        <div className='overflow-x-scroll lg:overflow-auto '>
                            <table className='lg:w-full'>
                                <tr className='text-xs lg:text-base border-b-2 text-center'>
                                    <td className='text-center'>Trạng thái</td>
                                    <td className='text-center'>Mệnh giá</td>
                                    <td className='text-center'>Thực nhận</td>
                                    <td className='text-center'>Seri/Mã thẻ</td>
                                    <td className='text-center'>Mã GD</td>
                                </tr>
                                {history &&
                                    history.slice(pageStart, pageEnd).map((item) => {
                                        return (
                                            <tr className='text-xs border-b-2'>
                                                <td className='text-center px-2'><StatusBadge status={item.status}/><br />{item.type}</td>
                                                <td className='text-center px-2'>{item.amount}</td>
                                                <td className='text-center px-2'>{item.thucnhan}</td>
                                                <td className='text-center px-2'>{item.seri}<br />{item.pin}</td>
                                                <td className='text-center px-2'>{item.code}</td>
                                            </tr>
                                        )
                                    })}
                            </table>
                        </div>
                        <div className='flex mt-2 justify-center gap-2 flex-wrap'>
                            <div
                                className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer flex items-center text-xs lg:text-base'
                                onClick={() => handleClickLeft()}>
                                <BsChevronLeft />
                            </div>
                            {Array(totalPage)
                                .fill(0)
                                .map((_, index) => {
                                    const pageItem = index + 1
                                    return (
                                        <div
                                            className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer'
                                            onClick={() => handleClick(Number(index))}>
                                            {pageItem}
                                        </div>
                                    )
                                })}
                            <div
                                className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer flex items-center text-xs lg:text-base'
                                onClick={() => handleClickRight()}>
                                <BsChevronRight />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ChangeHistory
